<template>
  <fn-form
    v-slot="form"
    ref="form"
    class="form-store-search"
    role="search"
    :errors="errors"
  >
    <fn-form-errors :errors="errors" />

    <fn-form-group>
      <fn-form-section>
        <fn-form-field-input
          id="address"
          v-model:value="queryText"
          name="address"
          vid="address"
          type="search"
          :value="query"
          :value-initial="searchPayloadInitial"
          :placeholder="placeholder"
          :rules="{
            required: true,
            max: 100,
          }"
          :action-icon="{
            icon: 'magnifying-glass',
            color: searchButtonOutside ? 'white' : 'green-dark',
            size: 'xs',
          }"
          :action-icon-aria-label="$t('accessibility.storefinder.searchStores')"
          :action-icon-outside="searchButtonOutside"
          @action-icon-click="form.handleSubmit(handleSubmit)()"
          @keydown.enter.prevent="form.handleSubmit(handleSubmit)()"
          @update:value="$emit('update:query', $event)"
        >
          <template #reset>
            <button
              v-if="searchInputFilled"
              id="form-search-reset"
              class="reset-button"
              :class="{
                'reset-button--single': searchButtonOutside,
              }"
              tabindex="0"
              role="button"
              :aria-label="$t('accessibility.general.resetInput')"
              @click.prevent="form.resetForm"
              @keydown.enter="form.resetForm"
            >
              <img
                src="@/assets/img/close-filled.svg"
                :alt="$t('buttons.delete')"
                role="presentation"
              />
            </button>
          </template>
        </fn-form-field-input>
      </fn-form-section>
    </fn-form-group>

    <fn-form-group v-if="!singleSection || locateMeNew">
      <fn-form-section>
        <template v-if="!singleSection">
          <div class="fss-locate-me">
            <fn-link
              id="storeListing-search-locateMe"
              bold
              pre-arrow
              role-button
              @click="$emit('locateMe')"
            >
              {{ $t('storeListing.search.locateMe') }}
            </fn-link>
          </div>
        </template>

        <template v-if="locateMeNew">
          <div class="fss-locate-me fss-locate-me--new">
            <fn-icon
              icon="location-pin-outline"
              size="s"
              role="presentation"
              color="green-dark"
            />
            <fn-link
              id="storeListing-search-locateMe"
              no-arrow
              role-button
              @click="$emit('locateMe')"
            >
              {{ $t('storeListing.search.locateMe') }}
            </fn-link>
          </div>
        </template>
      </fn-form-section>
    </fn-form-group>

    <fn-button
      v-if="ctaShown"
      quaternary-alt
      full-width
      @click.prevent="form.handleSubmit(handleSubmit)()"
    >
      {{ $t('buttons.showResults') }}
    </fn-button>
  </fn-form>
</template>

<script>
export default {
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: String,
      default: '',
    },
    singleSection: {
      type: Boolean,
    },
    locateMeNew: {
      type: Boolean,
      default: false,
    },
    searchPayloadInitial: {
      type: String,
      default: '',
    },
    searchButtonOutside: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
    mapShown: {
      type: Boolean,
    },
    ctaShown: {
      type: Boolean,
    },
  },
  emits: ['update:query', 'submit', 'locateMe'],
  data: () => ({
    queryText: '',
  }),
  computed: {
    searchInputFilled() {
      return this.queryText.length > 0;
    },
  },
  watch: {
    query(val) {
      this.queryText = val;
    },
    searchPayloadInitial(val) {
      this.queryText = val;
    },
  },
  mounted() {
    this.prefill();
  },
  methods: {
    handleResetClick() {
      this.queryText = '';
    },
    prefill() {
      this.queryText = this.searchPayloadInitial ? this.searchPayloadInitial : this.query;
    },
    handleSubmit() {
      this.$emit('submit', this.queryText);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-store-search {
  .reset-button {
    position: absolute;
    top: 0;
    right: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 45px;
    outline: 0;
    border: 0;
    background: transparent;
    cursor: pointer;

    &:after {
      content: '';
      position: absolute;
      right: 0;
      top: 25%;
      height: 50%;
      border-right: 1px solid palette(sand, light);
    }

    &:focus-visible {
      @include focus-outline-layered-circle-icon;
    }

    &.reset-button--single {
      right: 56px;

      &:after {
        display: none;
      }
    }
  }

  :deep(input) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 $pad * 2 0 $pad;
  }

  .fss-locate-me--new,
  .fss-map-toggle {
    display: flex;
    gap: 10px;

    :deep(.link) {
      color: $color-general-text-brand-default;
      font-size: map-get($font-sizes, l);
    }
  }

  .fss-map-toggle {
    :deep(.icon) {
      margin-left: auto;
    }
  }
}
</style>
